import { createContext } from "react";

import type { ProductsListType } from "../types";

export type ProductsBannerContextType = ProductsListType;

export const ProductsBannerContext =
  createContext<ProductsBannerContextType | null>(null);
